<template>
  <div
    :id="id"
    class="list-group-item cursor-pointer d-flex align-items-stretch rs-sidebar-card-list-group-item p-0"
    :class="{ active }"
  >
    <div
      class="py-2 px-3 text-truncate flex-fill"
      :title="title"
      @click="$emit('click')"
    >
      <div class="titles font-weight-bold rs-text-secondary text-truncate mb-1">
        {{ title }}
      </div>
      <small class="d-block rs-text-medium text-truncate">
        {{ subtitle }}
      </small>
    </div>
    <div
      v-if="isDeletePermitted"
      class="align-items-center rs-bg-light rs-text-medium p-3 hovered"
    >
      <i
        class="far fa-trash"
        @click="$emit('on-remove')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    id: String,
    title: String,
    subtitle: String,
    active: Boolean,
  },
  data() {
    return {
      hover: false,
    };
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables.scss";

.rs-sidebar-card-list-group-item {
  &.list-group-item {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: solid 1px $border-color;
  }

  .hovered {
    display: none;
  }

  &.active, &.list-group-item.active {
    background-color: rgba(0, 0, 0, 0.04);
    border-right: 0;
    border-top: 0;
    border-left: solid 6px $secondary-color;
    border-bottom: solid 1px $border-color;

    .titles {
      color: $secondary-color;
    }
  }

  &:hover {
    .titles {
      color: $secondary-color;
    }

    .hovered {
      display: flex;
    }
  }
}
</style>
